import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Remover from "../components/Remover";

type TrackerLineProps = {
    id: number;
    name: string;
    hardware_id: string;
    battery: number;
    version: number;
    last: string;
    updatable: boolean;
    server_url: string;
    server_port: number;
    fleetstate: string;
    removed: boolean;
    selected: boolean;
    onEdit: () => void;
    onRemove: () => void;
    onSelect: (select: boolean) => void;
};

export default function TrackerLine({id, name, hardware_id, battery, version, last, updatable, server_url, server_port, fleetstate, removed, selected, onEdit, onRemove, onSelect}: TrackerLineProps) {
    return (
        <tr className={ "tracker-line" + (removed?' removed':'')}>
            <td className="tracker-bulk-action pointer">
                <span className="toggle">
                    { selected
                        ? <FontAwesomeIcon icon="check-square" size="lg" onClick={() => onSelect ? onSelect(false) : null}/>
                        : <div className="to-check" onClick={() => onSelect ? onSelect(true) : null}>+</div>
                    }
                </span>
            </td>
            <td className="tracker-name">{ name }</td>
            <td className="tracker-hardware_id">{ hardware_id }</td>
            <td className="tracker-battery">{ battery }</td>
            <td className="tracker-version">{ version }</td>
            <td className="tracker-date">{ last }</td>
            <td className="tracker-url">{ server_url }</td>
            <td className="tracker-port">{ server_port }</td>
            <td className="tracker-action tracker-fleetstate">
                { fleetstate && <FontAwesomeIcon
                    icon="circle"
                    data-tooltip-id="info-filter"
                    data-tooltip-content={fleetstate}
                    style={{ color: fleetstate === 'ok' ? 'limegreen' : fleetstate.startsWith('outdated:') ? 'orange' : 'red' }}
                /> }
            </td>
            <td className="tracker-action tracker-action-updatable pointer">
                <FontAwesomeIcon icon="pencil-alt" onClick={() => onEdit()}/>
            </td>
            <td className="tracker-action tracker-action-remove pointer">
                <Remover id={id} onRemove={() => onRemove()}/>
            </td>
        </tr>
    );
};
